<template>
  <b-container class="p-0 px-sm-0">
    <b-card
      header-bg-variant="dark"
      header-border-variant="dark"
      header-text-variant="white"
      header-tag="header"
      border-variant="dark"
      class="main-card"
    >
      <template #header class="card-header px-0">
        <router-link to="/member/numbersets">
          <i class="fas fa-chevron-left"></i> จัดการเลขชุด
        </router-link>
      </template>
      <b-row>
        <b-col>
          <h5>
            <i class="fas fa-file-alt"></i> รายละเอียดเลขชุด
          </h5>
        </b-col>
        <b-col class="text-right">
          <b-button class="golden-btn" size="sm" @click="deleteNumberSet">
            <i class="fas fa-trash-alt"></i> ลบรายการนี้
          </b-button>
        </b-col>
      </b-row>
      <div class="w-100 mt-2 mb-3 border-bottom"></div>
      <b-row>
        <b-col cols="12" md="6" class="text-secondary">
          <i class="fas fa-tag"></i> ชื่อชุด: {{item.numberSetName}}
        </b-col>
        <b-col cols="12" md="6" class="text-secondary text-md-right text-lg-right text-xl-right">
          <i class="fas fa-calendar"></i> สร้างเมื่อ: {{formatDate(item.createdDate)}}
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col cols="12">
          <b-table striped hover :items="item.NumberSets" :fields="fields">
            <template #thead-top>
              <b-tr>
                <b-th colspan="3" variant="secondary">
                  <h5 class="mb-0 text-secondary">ชุดตัวเลข</h5>
                </b-th>
              </b-tr>
            </template>
            <template #cell(index)="data">
              <div>{{data.index + 1}}</div>
            </template>
            <template #cell(number)="data">
              <div>{{data.item.number}}</div>
            </template>
            <template #cell(numberType)="data">
              <div>{{options[data.item.numberType-1].text}}</div>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </b-card>
  </b-container>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import { mapActions, mapGetters } from "vuex";
import axios from "axios";
import moment from "moment";

export default {
  name: "Detail",
  props: ['page', 'id'],
  data() {
    return {
      options: [
        { value: 1, text: "3 ตัวบน", digit: 3 },
        { value: 2, text: "3 ตัวโต๊ด", digit: 3 },
        { value: 3, text: "2 ตัวบน", digit: 2 },
        { value: 4, text: "2 ตัวโต๊ด", digit: 2 },
        { value: 5, text: "วิ่งบน", digit: 1 },
        { value: 6, text: "2 ตัวล่าง", digit: 2 },
        { value: 7, text: "วิ่งล่าง", digit: 1 },
        { value: 8, text: "3 ตัวท้าย", digit: 3 }
      ],
      fields: [
        {
          key: "index",
          label: "ลำดับ"
        },
        {
          key: "numberType",
          label: "ประเภท"
        },
        {
          key: "number",
          label: "ตัวเลข"
        }
      ],
      item: []
    };
  },
  mounted() {
    this.getNumberSets();
  },
  methods: {
    formatDate(createdDate) {
      return moment(String(createdDate)).format('DD/MM/YYYY hh:mm');
    },
    deleteNumberSet() {
      this.$bvModal.msgBoxConfirm('ต้องการลบเลขชุดนี้หรือไม่', {
          title: 'ลบเลขชุด',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'ลบ',
          cancelTitle: 'ยกเลิก',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          // console.log(value);
          if(value) {
            axios.post(this.getApiUrl + "/pingpong/deleteNumberSet",
              {
                username: this.getUsername,
                numberSetID: this.id
              },
              {
                headers: {
                  "Content-Type": "application/json",
                  "token": this.getAccessToken,
                  "username": this.getUsername
                }
              } )
              .then(response => {
                console.log(response);
                if(response.data.statusCode == 200) {
                  this.$router.push("/member/numbersets");
                }
              });
          }
        });
    },
    async getNumberSets() {
      axios.post(this.getApiUrl + "/pingpong/getNumberSetById",
        {
          username: this.getUsername,
          numberSetID: this.id
        },
        {
          headers: {
            "Content-Type": "application/json",
            "token": this.getAccessToken,
            "username": this.getUsername
          }
        } )
        .then(response => {
          console.log(response);
          if(response.data.statusCode == 200) {
            this.item = response.data.data;
          }
          // else {
          // }
        });
    }
  },
  computed: {
    ...mapGetters({
      getAccessToken: "getAccessToken",
      getUsername: "getUsername",
      getCashAmount: "getCashAmount",
      getApiUrl: "getApiUrl"
    })
  }
};
</script>

<style lang="scss" scoped>
.main-card {
  min-height: calc((100vh - 104px) - 49px);
}

.card-header {
  font-size: 90%;
  line-height: 90%;

  a {
    color: #bbbbbb;

    &:hover {
      color: #bd841b;
      text-decoration: none;
    }
  }
}

h5 {
  color: #bd841b;
  font-weight: bold;
}

.button {
  &-warning {
    background-color: #bd841b;
    border-color: #bd841b;
    color: #ffffff;
  }

  &-outline-warning {
    color: #bd841b;
    border-color: #bd841b;
  }

  &:hover,
  &:focus,
  &:active {
    background-color: #bd841b;
    border-color: #bd841b;
    outline: none;
    box-shadow: none;
    color: #ffffff;
  }
}
</style>